import "babel-polyfill";
import * as bootstrap from "bootstrap";

import SimpleParallax from "simple-parallax-js/vanilla";
// Styling
import "../scss/style.scss";

// Fontawesome
import { dom, library } from "@fortawesome/fontawesome-svg-core";
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from "@fortawesome/free-brands-svg-icons";
library.add(faFacebookF, faTwitter, faInstagram, faLinkedinIn);
dom.watch();

// General
jQuery(document).ready(function ($) {
    if ($(".login.wp-core-ui").length) {
        $("#user_login").attr("placeholder", "Gebruikersnaam of e-mailadres");
        $("#user_pass").attr("placeholder", "Wachtwoord");
    }

    //Fixed animation interference
});
document.addEventListener("DOMContentLoaded", function () {
let lastShown = localStorage.getItem("lastShown") ?? 0;
    if (Date.now() - lastShown > 86400000 && Date.now() > 1745416067361 + 86400000) {
        setTimeout(function () {
            var offerBox = document.querySelector(".offer-fixed");
            if (offerBox) {
                offerBox.classList.add("open");

            setTimeout(function () {
                offerBox.classList.add("adjust-position");
            }, 500);
        }

        localStorage.setItem("lastShown", Date.now()); // Store flag in localStorage
    }, 900);
    }
    document.addEventListener("click", function (event) {
        if (event.target.classList.contains("close-button")) {
            var offerBox = document.querySelector(".offer-fixed");
            if (offerBox) {
                offerBox.classList.remove("open", "adjust-position");
                offerBox.classList.add("hide");
                setTimeout(() => {
                    offerBox.style.display = "none";
                }, 500);
            }
        }
    });

    // Search
    let searchField = document.querySelector(".search-field");
    if (searchField) {
        searchField.addEventListener("input", function () {
            // set accodionitems
            accordionitems.forEach((item) => {
                if (item.innerHTML.includes(searchField.value)) {
                    item.style.display = "block";
                } else {
                    item.style.display = "none";
                }
            });
        });
    }

    let timeBrackets=[];
    document.querySelectorAll(".taste-tabs .nav-item").forEach((x) => {
        let timeslot=x.querySelector(".tab-timeslot").innerText;
        if(timeslot && timeslot!==''){
            timeBrackets[timeslot]=x;
        }
        
        x.addEventListener("click", function () {
            if (window.innerWidth < 992) {
                const order = this.getAttribute("data-order");
                document.querySelector(".tab-content").style.order = order;
            }
        });
    });
   
    let found=false;
    Object.entries(timeBrackets).forEach(([timeslot,tab])=>{
        let currentHour=new Date().getHours();
        let currentMinutes=new Date().getMinutes();
        let slots = timeslot.split("-");
        slots.forEach((slot)=>{
            slot ={
                hour:parseInt(slot.split(":")[0]),
                minutes:parseInt(slot.split(":")[1])
            }
        })

        if(currentHour>=slots[0].hour && currentHour<=slots[1].hour && currentMinutes>=slots[0].minutes && currentMinutes<=slots[1].minutes){
            tab.classList.add("active");
            found=true;
        }
    })
    if(!found){
        let closestTimeSlot=null;
        let closestTimeDiff=null;
        let currentHour=new Date().getHours();
        let currentMinutes=new Date().getMinutes();
        console.log(timeBrackets);
        Object.entries(timeBrackets).forEach(([timeslot,tab])=>{
            console.log('test');
            let slots = timeslot.split("-");
            slots = slots.map((slot)=>{
                return {
                    hour:parseInt(slot.split(":")[0]),
                    minutes:parseInt(slot.split(":")[1])
                }
            })
            console.log(slots);
            let timeDiff1 = (slots[0].hour-currentHour)*60 + (slots[0].minutes-currentMinutes);
            let timeDiff2 = (slots[1].hour-currentHour)*60 + (slots[1].minutes-currentMinutes);
            if(timeDiff1>0 && (!closestTimeDiff || timeDiff1<closestTimeDiff)){
                closestTimeSlot=tab;
                closestTimeDiff=timeDiff1;
            }
            if(timeDiff2>0 && (!closestTimeDiff || timeDiff2<closestTimeDiff)){
                closestTimeSlot=tab;
                closestTimeDiff=timeDiff2;
            }
            console.log(timeDiff1,timeDiff2)
        })
        console.log(closestTimeSlot)
        if(closestTimeSlot){
            console.log("found");
            setTimeout(() => {
                // const bsTab = new bootstrap.Tab(closestTimeSlot)
                // bsTab.show();
                closestTimeSlot.click();
                document.querySelectorAll(".taste-tabs .nav-link").forEach((x)=>{
                    x.classList.remove("active");
                })
                closestTimeSlot.children[0].classList.add("active");
                let order = closestTimeSlot.getAttribute("data-order");
                document.querySelectorAll(".tab-pane.active").forEach((x)=>{
                    x.classList.remove("show",'active');
                })
                if(window.innerWidth<992){
                    document.querySelector(".tab-content").style.order = order;
                }
                let tabContent=document.querySelector(closestTimeSlot.children[0].dataset.bsTarget);
                tabContent.classList.add("show",'active');
                const newClickEvent = new Event('click');
                closestTimeSlot.dispatchEvent(newClickEvent);
            }, 100);
            found=true;
        }
        
    }

    //Voor filter
    let page = 1;
    function loadMore() {
        let postholder = document.querySelector(".post-holder");
        let inputs = document.querySelectorAll(".filter-input");
        let params = new URLSearchParams();
        params.set("page", page);
        inputs.forEach((input) => {
            if (input.name != "") {
                if (input.type == "checkbox" || input.type == "radio") {
                    if (input.checked) {
                        params.append(input.name, input.value);
                    }
                } else if (input.value != "") {
                    params.set(input.name, input.value);
                }
            }
        });
        postholder.scrollIntoView();

        fetch(JSONURL+`/limnonari/v1/${postholder.dataset.type}?${params.toString()}`)
            .then((response) => response.json())
            .then((data) => {
                postholder.innerHTML = data.html;
                document.querySelector(".pagination-wrap").innerHTML = data.pagination;
            });
    }
    if (document.querySelectorAll(".filter-input").length) {
        const selects = document.querySelectorAll(".filter-input");
        var hasSelection = false;
        try {
            hasSelection = [...selects].some((select) => select.name != "sort" && select.options[select.selectedIndex].value != "");
        } catch (e) {
            // cant find selectedIndex
        }
        const hasChecked = [...document.querySelectorAll(".filter-input")].some((input) => (input.type == "checkbox" || input.type == "radio") && input.checked);
        if (hasSelection || hasChecked) {
            loadMore();
        } else {
            const pageAccessedByReload =
                (window.performance.navigation && window.performance.navigation.type === 1) ||
                window.performance
                    .getEntriesByType("navigation")
                    .map((nav) => nav.type)
                    .includes("reload");

        }
    }
    let timeout;
    document.querySelectorAll(".filter-input").forEach((input) => {
        input.addEventListener("input", () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                page = 1;
                loadMore();
            }, 500);
        });
    });

    document.querySelectorAll(".pagination-wrap").forEach((x) => {
        x.addEventListener("click", (event) => {
            if (event.target.classList.contains("pagination-item")) {
                page = event.target.dataset.page;
                let postholder = document.querySelector(".post-holder");
                postholder.scrollIntoView();
                loadMore();
            }
        });
    });

    document.querySelectorAll(".reset").forEach((x) => {
        x.addEventListener("click", () => {
            document.querySelectorAll(".filter-input").forEach((input) => {
                if (input.type == "checkbox" || input.type == "radio") {
                    input.checked = false;
                } else if (input.type == "select") {
                    input.value = "";
                } else {
                    if(input.name.includes('min')) {
                        input.value = input.min;
                    }else if(input.name.includes('max')) {
                        input.value = input.max;
                    } else {
                        input.value = "";
                    }
                }
            });
            page = 1;
            loadMore();
        });
    });

    function swiperScrollbar(swiper, scrollbarEl, slideCount) {
        if (typeof scrollbarEl == "string") {
            scrollbarEl = document.querySelector(scrollbarEl);
        }
        scrollbarEl.innerHTML = "";
        let inputElement = document.createElement("input");
        inputElement.type = "range";
        inputElement.classList.add("custom-scrollbar");
        inputElement.min = 0;
        inputElement.max = 1000;
        inputElement.value = 0;
        inputElement.style.setProperty("--width", `${100 / slideCount}%`);
        let stepSize = 1000 / (slideCount - 1);
        inputElement.addEventListener("input", () => {
            let truevalue = Math.round((inputElement.value / 1000) * (slideCount - 1));
            swiper.slideTo(truevalue);
        });
        inputElement.addEventListener("change", () => {
            // smoothly lock onto true value for the slide in the range element
            let truevalue = Math.round(inputElement.value / stepSize);

            let difference = truevalue * stepSize - inputElement.value;

            let interval = setInterval(() => {
                let newValue = inputElement.value + difference / 10 < truevalue * stepSize ? inputElement.value + difference / 10 : truevalue * stepSize;
                inputElement.value = newValue;
                if (inputElement.value >= truevalue * stepSize) {
                    clearInterval(interval);
                }
            }, 100);
        });
        swiper.on("slideChange", () => {
            inputElement.value = swiper.realIndex * stepSize;
        });
        scrollbarEl.insertAdjacentElement("beforeend", inputElement);
    }

    document.querySelectorAll(".limonari-slider").forEach((x) => {
        let slideCount = x.querySelectorAll(".swiper-slide").length;
        let swiperlimonari = new Swiper(x.querySelector(".limonari-swiper"), {
            slidesPerView: 1.2,
            centeredSlides: true,
            grabCursor: true,
            spaceBetween: 24,
            loop: true,
            navigation: {
                nextEl: ".limonari-slider .swiper-button-next",
                prevEl: ".limonari-slider .swiper-button-prev",
            },

            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                },
            },

            // Reinitialize AOS after Swiper initialization
            on: {
                init: function () {
                    AOS.refresh();
                },
                slideChangeTransitionEnd: function () {
                    AOS.refresh();
                },
            },
        });

        swiperScrollbar(swiperlimonari, x.querySelector(".custom-swiper-scrollbar"), slideCount);
    });
    
    document.querySelectorAll(".church-slider-block").forEach((slider) => {
        var lastSlideIndex = slider.querySelectorAll(".swiper-slide").length;
        let lastSlideIndexswiperchurches = new Swiper(slider.querySelector(".churches-swiper"), {
            slidesPerView: 2.5,
            grabCursor: true,
            spaceBetween: 24,
            initialSlide: lastSlideIndex,

            loop: true,

            navigation: {
                nextEl: slider.querySelector(".swiper-button-next"),
                prevEl: slider.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                360: {
                    slidesPerView: 1.3,
                },
                540: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 2.3,
                },
                1280: {
                    slidesPerView: 3,
                },
                1440: {
                    slidesPerView: 3,
                },
                1600: {
                    slidesPerView: 3,
                },
                1920: {
                    slidesPerView: 4,
                },
                3020: {
                    slidesPerView: 5,
                },
            },

            // Reini tialize AOS after Swiper initialization
            on: {
                init: function () {
                    AOS.refresh();
                },
                slideChangeTransitionEnd: function () {
                    AOS.refresh();
                },
            },
        });
        swiperScrollbar(lastSlideIndexswiperchurches, slider.querySelector(".custom-swiper-scrollbar"), lastSlideIndex);
    });

    document.querySelectorAll(".teamslider").forEach((slider) => {
        let lastSlideIndex = slider.querySelectorAll(".swiper-slide").length;
        let lastSlideIndexswiperchurches = new Swiper(slider.querySelector(".teams-swiper"), {
            slidesPerView: 1.2,
            grabCursor: true,
            spaceBetween: 24,
            // initialSlide: lastSlideIndex,

            loop: true,

            navigation: {
                nextEl: slider.querySelector(".swiper-button-next"),
                prevEl: slider.querySelector(".swiper-button-prev"),
            },
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1280: {
                    slidesPerView: 4,
                },
                1440: {
                    slidesPerView: 5,
                },
            },

            // Reinitialize AOS after Swiper initialization
            on: {
                init: function () {
                    AOS.refresh();
                },
                slideChangeTransitionEnd: function () {
                    AOS.refresh();
                },
            },
        });
        swiperScrollbar(lastSlideIndexswiperchurches, slider.querySelector(".custom-swiper-scrollbar"), lastSlideIndex);
    });
    // Initialize AOS

    //Wedding images-swiper
    
    document.querySelectorAll(".imageslider").forEach((slider) => {
         let slideCount = slider.querySelectorAll(".swiper-slide").length;
        let swiperimg = new Swiper(".images-swiper", {
        slidesPerView: 1.5,
        grabCursor: true,
        spaceBetween: 0,
        autoplay: {
       delay: 1000,
       disableOnInteraction: false,
   },

        loop: true,

        navigation: {
            nextEl: " .swiper-button-next",
            prevEl: " .swiper-button-prev",
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
            },
            992: {
                slidesPerView: 3,
            },
            1280: {
                slidesPerView: 5,
            },
        },

        // Reinitialize AOS after Swiper initialization
        on: {
            init: function () {
                AOS.refresh();
            },
            slideChangeTransitionEnd: function () {
                AOS.refresh();
            },
        },
    });

    });

    //

    document.querySelectorAll("a[href^='#']").forEach((x) => [
        x.addEventListener("click", function (e) {
            if (x.href.includes("#")) {
                e.preventDefault();
                const targetId = x.getAttribute("href").substring(1);
                const targetElement = document.getElementById(targetId);
                console.log(targetElement);
                if (targetElement) {
                    targetElement.scrollIntoView({ behavior: "smooth" });
                    targetElement.click();
                }
            }
        }),
    ]);
    // Initialize AOS
    AOS.init({
        duration: 800, // Animation duration
        once: true, // Only animate once
    });

    document.querySelectorAll(".rooms-swiper-container").forEach((x) => {
        let slideCount = x.querySelectorAll(".swiper-slide").length;
        let swiperrooms = new Swiper(x.querySelector(".rooms-swiper"), {
            slidesPerView: 2.5,
            grabCursor: true,
            spaceBetween: 24,
            loop: true,

            breakpoints: {
                360: {
                    slidesPerView: 1.3,
                },
                540: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 2,
                },
                1025: {
                    slidesPerView: 4,
                },
            },

            // Reinitialize AOS after Swiper initialization
            on: {
                init: function () {
                    AOS.refresh();
                },
                slideChangeTransitionEnd: function () {
                    AOS.refresh();
                },
            },
        });

        swiperScrollbar(swiperrooms, x.querySelector(".custom-swiper-scrollbar"), slideCount);
        document.querySelectorAll(".room-button-next").forEach((element) => {
            element.addEventListener("click", (e) => {
                swiperrooms.slideNext();
            });
        });
        x.querySelectorAll(".room-button-prev").forEach((element) => {
            element.addEventListener("click", (e) => {
                swiperrooms.slidePrev();
            });
        });
    });

    // special swiper
    document.querySelectorAll(".offerslider").forEach((x) => {
        let slideCount = x.querySelectorAll(".swiper-slide").length;
        let swiperoffer = new Swiper(".offers-swiper", {
            slidesPerView: 1.2,
            grabCursor: true,
            spaceBetween: 24,
            centeredSlides: true,
            roundLengths: true,

            loop: slideCount>5,

            navigation: {
                nextEl: " .swiper-button-next",
                prevEl: " .swiper-button-prev",
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                992: {
                    slidesPerView: 3,
                },
                1280: {
                    slidesPerView: 5.4,
                },
            },

            // Reinitialize AOS after Swiper initialization
            on: {
                init: function () {
                    AOS.refresh();
                },
                slideChangeTransitionEnd: function () {
                    AOS.refresh();
                },
            },
        });
        swiperScrollbar(swiperoffer, x.querySelector(".custom-swiper-scrollbar"), slideCount);
    });

    // var images = document.querySelectorAll(".parallax");
    // new SimpleParallax(images, {
    //     delay: 0.2,
    //     orientation: "down",
    //     scale: 1.4,
    //     maxTransition:20
    // });


    document.querySelectorAll("[data-aos]").forEach((x) => {
           x.addEventListener(
                "transitionend",
                () => {
                    delete x.dataset.aos;
                },
                true
            );
       if(x.className.includes('clone')){
        delete x.dataset.aos;
       }
    });
});

//animate-on-scroll effect

document.addEventListener("DOMContentLoaded", function () {
    const elements = document.querySelectorAll(".animate-on-scroll");

    function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight - 75 && rect.bottom > 0;
    }

    function animateElements() {
        elements.forEach((el) => {
            if (isInViewport(el)) {
                el.classList.add("show");
            }
            // else {
            //
            //   el.classList.remove('show');
            //  }
        });
    }

    window.addEventListener("scroll", animateElements);
    window.addEventListener("resize", animateElements);
    window.addEventListener("load", animateElements);

    animateElements(); //  run once on load
});

// Cursor Effect 

window.addEventListener("load", (event) => {
    new cursoreffects.followingDotCursor();
});


//#scrollbar-indicator

window.addEventListener('scroll', function () {
    const indicator = document.getElementById('scrollbar-indicator');
    const scrollTop = window.scrollY;
    const docHeight = document.body.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;
    indicator.style.width = scrollPercent + '%';
});
